import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type CourseContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, bookmark?: { id: string } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null } | null };


export type CourseContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type CourseContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, bookmark?: { id: string } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type CourseContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const CourseContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment CourseContentCard on CourseContentType {
  id
  name
  type
  duration
  description
  status
  cover {
    ...EntityMedia
  }
  bookmark {
    id
  }
  performance {
    id
    status
    progress
    estimatedTimeSpent
  }
}
    `;
export const CourseContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment CourseContentCardWithUserPerformance on CourseContentType {
  id
  name
  type
  duration
  description
  status
  cover {
    ...EntityMedia
  }
  bookmark {
    id
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;